import { render, staticRenderFns } from "./YouTubeActiveVideo.vue?vue&type=template&id=4cc7cf61"
import script from "./YouTubeActiveVideo.vue?vue&type=script&lang=js"
export * from "./YouTubeActiveVideo.vue?vue&type=script&lang=js"
import style0 from "./YouTubeActiveVideo.vue?vue&type=style&index=0&id=4cc7cf61&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports